module.exports = __webpack_public_path__ + "img/8.4130c51c.png";